export default {
  state: {
    productButtonFilterMap: {},
    animationProductFilterMap: {}
  },
  mutations: {
    setProductButtonFilterMap(state, payload) {
      state.productButtonFilterMap = payload;
    },
    setAnimationProductFilterMap(state, payload) {
      state.animationProductFilterMap = payload;
    }
  },
  actions: {
    createProductButtonFilterMap({ commit, rootState }) {
      let tempObj = {};
      rootState.productBar.products.forEach((product) => {
        rootState.macroAnimations.forEach((animation) => {
          if (animation.productsInAnimationIds.includes(product.id)) {
            if (!tempObj[product.id]) {
              tempObj[product.id] = [animation.numId];
            } else {
              tempObj[product.id].push(animation.numId);
            }
          }
        });
      });
      commit('setProductButtonFilterMap', tempObj);
    },
    createAnimationProductFilterMap({ commit, rootState }) {
      let tempObj = {};

      rootState.macroAnimations.forEach((animation) => {
        tempObj[animation.numId] = animation.productsInAnimationIds;
      });

      commit('setAnimationProductFilterMap', tempObj);
    }
  }
};
